import { Member } from '../profile/profile/member.model';

export class Invite {
  userId: string;
  groupId: number;
  memberId: number;
}
